import { RouteConfig } from "vue-router";
import VacancyComponent from "./vacancies.vue";
import { Roles } from "@/types/enums.type";

export default [
  {
    path: "/vacancies",
    name: "VacancyComponent",
    component: VacancyComponent,
    meta: {
      roles: [Roles.PracticeUser, Roles.OfficeUser],
      nav: true,
      navTitle: "For Hire",
      navIcon: "icon-h",
      customNavIcon: true
    }
  }
] as RouteConfig[];